export default function PHP_array_shift() {
  return (
    <div>
      <h1>PHP_array_shift</h1>
    </div>
  );
}
